<template>
    <form action="#" class="form" v-on:submit.prevent ref="form">
        <div class="fields-group">
            <field-wrapper @focus="error" :isError="error" type="email" v-model="email" label="Логин" :options="{required: true}" id="email"></field-wrapper>
            <field-wrapper @focus="error" :isError="error" type="password" v-model="password" label="Пароль" :options="{required: true}" id="password"></field-wrapper>
            <div class="checkbox-item form-view">
                <input v-model="remember" id="remember-me" name="remember-me" type="checkbox">
                <label for="remember-me">Запомнить меня</label>
                <router-link class="forgot" :to="{name: 'reset-password'}">Забыли пароль?</router-link>
            </div>

        </div>
        <button  type="submit" class="btn" @click="btnLogin" :disabled="loading">Войти</button>
    </form>
</template>

<script>
    import FieldWrapper from "../common/fields/FieldWrapper";
    import axios from 'axios'
    import {NOTIFICATION_WARNING} from "../../constants/common";

    export default {
        name: 'user-login-form',
        components: {
            FieldWrapper
        },
        data() {
            return {
                loading: false,
                password: '',
                error: false,
                type: 'user',
                email: '',
                remember: false
            }
        },
        computed: {},
        methods: {
            btnLogin() {
                if (!this.$refs.form.checkValidity()) {
                    this.$refs.form.reportValidity();
                } else {
                    this.loading = true;
                    axios.post('/api/login' , {email: this.email, password: this.password, remember: this.remember})
                        .then((response) => {
                            if (response.data.success) {
                                window.location.href = "/";
                            } else {
                                let text = response.data.error;
                                this.$store.dispatch('pushNotification', {type: NOTIFICATION_WARNING, text: text, time: 5000});
                                this.error = true
                            }
                            this.loading = false;
                        })
                        .catch((error) => {
                            this.$store.dispatch('errorHandler', error);
                            this.loading = false;
                        });
                }
            },

        },

    }
</script>


<style scoped>
    .forgot {
        float: right;
    }

</style>
